import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { DataType, TableColumn } from '@etech-flex-sre/ls-sortable-table';
import { OrgUnit } from 'src/app/interfaces/org-unit';
import { Permissions } from 'src/app/interfaces/permissions';
import { ModalService } from 'src/app/services/modal.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-permissions-modal',
    templateUrl: './permissions-modal.component.html',
    styleUrls: ['./permissions-modal.component.scss'],
    standalone: false
})
export class PermissionsModalComponent implements OnInit, AfterViewInit, OnDestroy {
	public columns:Array<TableColumn<Permissions>> = [
		{
			ColumnName: 'Population Name',
			ColumnKey: 'PopulationName',
			AutoSort: true,
			SortDirection: true,
			Sortable: true,
		},
		{
			ColumnName: 'Org Code',
			ColumnKey: 'OrgUnitCode',
		},
		{
			ColumnName: 'Can View',
			ColumnKey: 'CanView',
			DataType: DataType.Boolean,
		},
		{
			ColumnName: 'Can Schedule',
			ColumnKey: 'CanSchedule',
			DataType: DataType.Boolean,
		},
		{
			ColumnName: 'Can Manage',
			ColumnKey: 'CanManage',
			DataType: DataType.Boolean,
		},
		{
			ColumnName: 'Can Submit On Behalf',
			ColumnKey: 'CanOnBehalf',
			DataType: DataType.Boolean,
		},
		{
			ColumnName: 'Can Build Profiles',
			ColumnKey: 'CanBuild',
			DataType: DataType.Boolean,
		},
		{
			ColumnName: 'Is Admin',
			ColumnKey: 'IsAdmin',
			DataType: DataType.Boolean,
		},
	];
	public shownPermissions:Array<Permissions> = [];
	public selectedOrgUnits:Array<OrgUnit> = [];
	public selectedPermissions:Array<Permissions> = [];
	public permissions:Array<Permissions> = [];

  constructor(private modalService:ModalService,
		public permissionsService:PermissionsService) {

		this.permissionsService.permissionsChanged
			.subscribe((permissions) => {
				this.permissions = [...permissions]
        		this.shownPermissions = [];
			});

	}

	ngOnInit(): void {
	}

  ngAfterViewInit(): void {
		this.modalService.initModal('permissions-modal');
		this.modalService.addEventListener(
			'permissions-modal',
			'hidden.bs.modal',
			() => this.reset()
		);
	}

	ngOnDestroy(): void {
		this.modalService.disposeModal('permissions-modal');
	}

	updateFilterPopulations(selectedPermissions:Array<Permissions>) {
		const populationIds = selectedPermissions.map(p => p.PopulationID);
		this.shownPermissions = this.permissions.filter(p => populationIds.includes(p.PopulationID!));
	}

	reset() {
		this.shownPermissions = [];
		this.selectedOrgUnits = [];
		this.selectedPermissions = [];
    	this.permissions = [];
	}

}
